<template>

  <EntityManager
      heading="Контрагенти"
      heading-create="Нов контрагент"
      heading-modify="Редактиране на контрагент"
      heading-delete="Изтриване на контрагент"
      message-delete="Избраният контрагент ще бъде изтрит. Сигурни ли сте?"
      resource="/contragent" @select="onSelect" @create="onCreate">
    <template #table>
      <Column field="name" header="Име на контрагент"></Column>
      <Column field="category.name" header="Група"></Column>
      <Column field="mol" header="Материално отговорно лице"></Column>
    </template>
    <template v-slot:form="props">
      <div class="p-fluid p-grid" style="min-width: 720px; max-width: 720px">
        <div class="p-field p-col-12 p-md-7">
          <label for="name">Контрагент (име на фирма или физическо лице)</label>
          <InputText id="name" type="text" v-model.trim="props.entity.name"
            class="{ 'p-invalid': submitted && !item.name }" autofocus/>
          <small class="p-invalid"
            v-if="props.submitted && !props.entity.name">Името е задължително.</small>
        </div>
        <div class="p-field p-col-12 p-md-5 p-input-filled">
          <label for="category">Група</label>
          <AutoComplete v-model="props.entity.category" :dropdown="true" field="name"
            :suggestions="categories" @complete="searchCategory($event)" placeholder="Въведете група"/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="bulstat">Булстат</label>
          <InputText id="bulstat" type="text" v-model.trim="props.entity.company.bulstat" />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="vat">Номер по ДДС</label>
          <InputText id="vat" v-model="props.entity.company.vat" />
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="mol">Материално отговорно лице</label>
          <InputText id="mol" v-model="props.entity.company.mol" />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="phone">Телефон</label>
          <InputText id="phone" v-model="props.entity.contact.phone" placeholder="+359..." />
        </div>
        <div class="p-field p-col-12 p-md-5">
          <label for="email">Е-поща</label>
          <InputText id="email" v-model="props.entity.contact.email" />
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="web">Интернет страница</label>
          <InputText id="web" v-model="props.entity.contact.web" placeholder="https://" />
        </div>
      </div>
      <TabView id="contragent" style="max-width: 700px">
        <TabPanel header="Адрес по регистрация">
          <div class="p-fluid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="address">Адрес по регистрация</label>
              <InputText id="address" v-model="props.entity.company.address.address" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="zip">Пощ. код</label>
              <InputText id="zip" v-model="props.entity.company.address.zip" />
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="town">Град</label>
              <InputText id="town" v-model="props.entity.company.address.town" />
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="country">Държава</label>
              <InputText id="country" v-model="props.entity.company.address.country"
                placeholder="България" />
            </div>
            <div class="p-field p-col-12 p-md-12">
              <label for="notes">Бележки</label>
              <Textarea id="notes" v-model="props.entity.notes" :autoResize="true"
                rows="3" class="p-inpittextarea" />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Адрес за доставка">
          <div class="p-fluid p-grid">
            <div class="p-field p-col-12 p-md-4">
              <label for="address2">Адрес за доставка</label>
              <InputText id="address2" v-model="props.entity.delivery.address.address" />
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="zip2">Пощ. код</label>
              <InputText id="zip2" v-model="props.entity.delivery.address.zip" />
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="town2">Град</label>
              <InputText id="town2" v-model="props.entity.delivery.address.town" />
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="country2">Държава</label>
              <InputText id="country2" v-model="props.entity.delivery.address.country"
                placeholder="България" />
            </div>
            <div class="p-field p-col-12 p-md-12">
              <label for="notes">Особености, свързани с доставката</label>
              <Textarea id="notes" v-model="props.entity.delivery.notes" :autoResize="true"
                rows="3" class="p-inpittextarea" />
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Търговски условия">
          <div class="p-fluid p-grid">
            <div class="p-field p-col-12 p-md-8">
              <label for="class">Ценови клас</label>
              <ToggleButton v-model="props.entity.wholesailer"
                  onLabel="Клиент по цени на едро"
                  offLabel="Клиент по цени на дребно" onIcon="pi pi-check" offIcon="pi pi-times"/>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="discount">Отстъпка %</label>
              <InputNumber ref="discount" id="discount" v-model="props.entity.discount" :format="true"/>
            </div>
          </div>
        </TabPanel>
      </TabView>
    </template>
  </EntityManager>

</template>

<script>

export default {
  data() {
    return {
      text: null,
      categories : []
    }
  },

  emits: {
    select: null
  },

  methods: {
    searchCategory(event) {
      var ctx = this;
      this.$http.get('/contragent-category', {
        params: {
          query: event.query
        }
      }).then(res => ctx.categories = res.data)
    },
    onSelect(data) {
      this.$emit('select', data);
    },
    onCreate(contragent) {
      contragent.company = {address: {}}
      contragent.contact = {}
      contragent.delivery = {address: {}}
    }
  }
}
</script>
